import makeStyles from '@mui/styles/makeStyles';

export const usePanelStyles = makeStyles((theme) => ({
   root: {
      padding: theme.spacing(3, 3),
      marginBottom: theme.spacing(2),
      position: 'relative',
      // borderColor: theme.palette.primary.main,
      // borderRadius: 2,
      // border: 'none',
      // boxShadow: '0px 2px 12px -6px rgb(89 130 212 / 81%)',
      marginTop: ({marginTop = 1}: {marginTop?: number}) => theme.spacing(marginTop),
   },
   collapsible: {
      padding: theme.spacing(5, 2, 3),
      boxShadow: `0px 2px 4px -1px ${theme.palette.secondary.main}, 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgb(0 0 0 / 12%)`,
   },
   rootPanel: {
      padding: theme.spacing(5, 2, 3),
      boxShadow: `0px 2px 4px -1px ${theme.palette.secondary.main}, 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgb(0 0 0 / 12%)`,
   },

   header: {
      width: '100%',
      position: 'absolute',
      top: '0px',
      left: '0px',
      borderTopLeftRadius: '5px',
      borderTopRightRadius: '5px',
      paddingRight: '1rem',
      color: theme.palette.secondary.main,
      // left: '-5px',
      // width: '100%',
      '$rootPanel > &, $collapsible > &': {
         cursor: 'pointer',
         background: theme.palette.secondary.main,
         color: 'white',
         borderBottom: `1px solid ${theme.palette.secondary.main}`,
         '& button': {
            color: 'inherit',
         },
         '&:hover .circular-btn': {
            background: 'rgba(255, 255, 255, 0.3)',
         },
      },
   },

   name: {
      marginLeft: '.5rem',
      //   padding: '0 3px',
      padding: '0 .5rem',
      ...theme.typography.caption,
      fontSize: '.9rem',
      fontWeight: 600,
      color: 'inherit',
      letterSpacing: '.15rem',
      textTransform: 'uppercase',

      // backgroundColor: theme.palette.background.paper,
      display: 'inline-block',
      // fontWeight: 'bold',
   },
}));
